export const getDefaultModel = t => [
  {
    id: 'da05be25-59ea-40d8-aa6a-b955f64ccbe2',
    label: t('defaultModels.0'),
  },
];
